import {Action} from '@ngrx/store';

export class GetBijbEventsAction implements Action {
  public static readonly type = 'GetBijbEventsAction';

  public type = GetBijbEventsAction.type;
}
